<template>
    <button class="mobile-menu-button" @click="mobileStore.toggleMobileNav">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 12H15M3 6H21M3 18H21" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </button>
</template>

<script setup lang="ts">
import { useMobileStore } from '~/stores/layout/mobile';

const mobileStore = useMobileStore();
</script>

<style lang="scss" scoped>
.mobile-menu-button {
    @apply flex lg:hidden p-2 cursor-pointer items-center justify-center;
    transition: background-color 0.2s;
    svg {
        @apply w-5 h-5;
    }
    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }
    @media screen and (max-width: 1024px) {
        @apply flex justify-end w-full -mt-6;
        justify-content: end !important;
    }
}
</style>
